module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "ep"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_c('span', {
    attrs: {
      "aria-label": "vii",
      "id": "pg_vii",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Beyond these walls")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv-bot"
  }, [_vm._v("Sweet freedom calls.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-Source-fmeps"
  }, [_vm._v("—Eugene V. Debs, 1918")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv-bot"
  }, [_vm._v("It was a long time ago now. And it was yesterday.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-Source-fmeps"
  }, [_vm._v("—Kate Atkinson, 2013")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv-bot"
  }, [_vm._v("What we now call the present, this fleeting "), _c('i', [_vm._v("nownownow")]), _vm._v(", is constantly overshadowed by a past now.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-Source-fmeps"
  }, [_vm._v("—G"), _c('span', {
    staticClass: "fm-epigraph-source-fmeps-_span-accent-characters-acc"
  }, [_vm._v("ü")]), _vm._v("nter Grass, 2007")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv-bot"
  }, [_vm._v("The suppressed past will rankle and return.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-Source-fmeps"
  }, [_vm._v("—Eva Hoffman, 2004")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6efe7073","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 69
// module chunks = 0